import { CustomRouteConfig } from "@/models/plugins/CustomRouterTypes";
import PERMISSIONS from "@/static/permissions";

const DeveloperRoutes: Array<CustomRouteConfig> = [
  {
    name: "Dev",
    path: "developer",
    meta: { hasOneOfPermissions: [PERMISSIONS.DeveloperRead] },
    redirect: { name: "Developer" },
  },
  {
    name: "Developer",
    path: "developer/developer",
    meta: { hasOneOfPermissions: [PERMISSIONS.DeveloperRead] },
    component: () => import(/* webpackChunkName: "developer" */ "@/views/developer/DeveloperView.vue"),
  },
  {
    name: "Connector",
    path: "developer/connector",
    meta: { hasOneOfPermissions: [PERMISSIONS.DeveloperRead] },
    component: () => import(/* webpackChunkName: "developer" */ "@/views/developer/ConnectorView.vue"),
  },
  {
    name: "Migrations",
    path: "developer/migrations",
    meta: { hasOneOfPermissions: [PERMISSIONS.DeveloperRead] },
    component: () => import(/* webpackChunkName: "developer" */ "@/views/developer/MigrationView.vue"),
  },
  {
    name: "KSEF",
    path: "developer/KSEF",
    meta: { hasOneOfPermissions: [PERMISSIONS.DeveloperRead] },
    component: () => import(/* webpackChunkName: "developer" */ "@/views/developer/KSEFView.vue"),
  },
];

export { DeveloperRoutes };
export default DeveloperRoutes;
